import { PostScoreGen7Response, ScoreItem } from '../services/amazingScoring/amazingScoring.types';
import { STRATEGY_LIST } from '../services/amazingScoring/amazingScoring.constants';
import { formDataToArrangeOkb } from '../store/adapters/formStore';
import { provider } from './client';

type ScoringResult = {
    task: PostScoreGen7Response['task'];
    scores?: Partial<Record<ValuesOf<typeof STRATEGY_LIST>, { score: number; isHit: boolean }>>;
};

export const setScoringTaskGen7 = async (formData: FE.FormData, userId?: string): Promise<ScoringResult> => {
    const scoringData = formDataToArrangeOkb(formData);
    const result = await provider.postScoringGen7(scoringData, userId).catch(() => ({}) as never);

    return createScoringResult(result);
};

export const loadScoringGen7 = async (taskId: string): Promise<ScoringResult> => {
    const result = await provider.checkScoringGen7(taskId).catch(() => ({}) as never);
    return createScoringResult(result);
};

function createScoringResult(result: PostScoreGen7Response) {
    return {
        task: result.task,
        ...(result.scores ? { scores: makeScoringData(result.scores) } : {}),
    };
}

const makeScoringData = (scores: Array<ScoreItem>) => {
    return scores.reduce<Partial<Record<ValuesOf<typeof STRATEGY_LIST>, { score: number; isHit: boolean }>>>(
        (acc, current) => {
            return Object.assign(acc, { [current.strategy]: { score: current.score, isHit: current.isHit } });
        },
        {},
    );
};
